// extracted by mini-css-extract-plugin
module.exports = {"details":"StepHeading_details__ITzmy","title":"StepHeading_title__VhPOc","description":"StepHeading_description__BxPIh"};